// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed, fontNormal } from "@fdr/static-ui/Typography";

import ButtonDefault from "../../_atoms/ButtonDefault";

export const RacingTipOuterContainer = styled.div`
  width: 100%;
  margin-top: 12px;
  border-top: 1px solid ${buildColor("grey", "300")};
`;

export const RacingTipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  ${({ isNewLayout }) => !isNewLayout && "background: rgb(34, 65, 104);"}
  ${({ isNewLayout }) => !isNewLayout && "border-radius: 4px;"}
  overflow: hidden;
  transition: max-height 0.3s ease-in;
  height: auto;
  max-height: fit-content;
  ${({ raceAnalystVerdictExpanded, timeformAnalystVerdict, isNewLayout }) =>
    !raceAnalystVerdictExpanded && timeformAnalystVerdict && !isNewLayout
      ? "min-height: 64px;"
      : "min-height: 40px;"}
  ${({ raceAnalystVerdictExpanded, timeformAnalystVerdict, isNewLayout }) =>
    !raceAnalystVerdictExpanded && timeformAnalystVerdict && isNewLayout
      ? "min-height: 40px;"
      : "min-height: 28px;"}
  padding: ${({ isNewLayout }) => (isNewLayout ? "12px 12px 0 0" : "12px")};
`;

export const RacingTipHeader = styled.div`
  display: flex;
  height: 18px;
  max-height: fit-content;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  ${({ timeformAnalystVerdict }) =>
    timeformAnalystVerdict &&
    css`
      margin-bottom: 8px;
    `};
`;

export const Tips = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > span:nth-child(even) {
    width: 16px;
    height: 16px;
  }
`;

export const Tip = styled.span`
  margin-left: ${({ isNewLayout }) => (isNewLayout ? "16px" : "8px")};
  margin-right: 4px;
  color: ${({ isNewLayout }) =>
    isNewLayout ? buildColor("grey", "900") : buildColor("grey", "300")};
  font-size: 12px;
  font-family: ${fontCondensed};
  text-transform: uppercase;
  letter-spacing: 1px;
  ${({ belowTheLine }) =>
    belowTheLine &&
    css`
      margin: 0 16px 0 0;

      &:first-of-type {
        margin-right: 17px;
      }

      &:last-of-type {
        margin: 0;
      }
    `}
`;

export const Spacer = styled.span`
  margin-right: 22px;
`;

export const Title = styled.span`
  color: ${buildColor("grey", "D4")};
  font-family: ${fontNormal};
  font-size: 14px;
  min-height: 17px;
  height: auto;
  max-height: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: ${({ isRAS }) => (isRAS ? "center" : "flex-start")};
`;

export const NumberFireLayout = styled.span`
  padding-left: 4px;
`;

export const RacingTipAnalystVerdict = styled.div`
  color: ${({ isNewLayout }) =>
    isNewLayout ? buildColor("grey", "D3") : "rgb(207, 214, 219)"};
  line-height: 125%;
  font-family: ${fontNormal};
  font-size: 14px;
  ${({ raceAnalystVerdictExpanded }) =>
    raceAnalystVerdictExpanded
      ? css`
          word-break: break-word;
          height: auto;
          width: 100%;
        `
      : css`
          white-space: nowrap;
          overflow: hidden;
          position: relative;
          display: inline-block;
          height: 17px;
          width: calc(100% - 32px);
        `}
  ${({ isNewLayout }) =>
    isNewLayout &&
    css`
      margin-top: 12px;
    `}
`;

export const BottomSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

// $FlowFixMe
export const AnyButton = styled(ButtonDefault)`
  width: 32px;
  height: 17px;
  color: ${buildColor("blue", "500")};
  font-size: 14px;
  font-family: ${fontNormal};
  box-shadow: -17px 0 9px 3px rgb(34, 65, 104);
  z-index: 20;
  position: relative;
`;

export const ExpandButtonWrapper = styled.span`
  width: 114px;
  height: 18px;
  display: flex;
  align-items: center;
`;

export const ExpandButton = styled(ButtonDefault)`
  height: 17px;
  color: ${buildColor("blue", "D1")};
  font-size: 14px;
  font-family: ${fontCondensed};
  font-weight: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;
`;
